export default __webpack_public_path__ + "static/media/bees2.1a9e158a.png";